<template>
  <a-layout class="layout" :class="[device]">
    <div v-if="roleCode === 'ebid_agency'||roleCode === 'ebid_bidder'||roleCode === 'expert'" class="floatBtn" style="z-index: 10000" >
<!--      <button @click="toggleSidebarCe">切换侧边栏</button>-->
      <div v-show="!isSidebarCeOpen">
        <div class="service" @click="openQQ()">
<!--          <a href="javascript:;"></a>-->
<!--&lt;!&ndash;          &lt;!&ndash;        <h3 id = "506434083" style="cursor: pointer"></h3>&ndash;&gt;&ndash;&gt;-->
          <div class="serviceTextDiv" :class="{active: serviceMouseOn}" @mouseleave="serviceMouseleave" style="padding-left: 10px">
            <div style="cursor: pointer;font-weight: bold;text-decoration:underline;  font-size: 15px; color: #FFFFFF; text-align: left; margin-top: 10px;" @click="openQQ('1')">
              <img src="~@/assets/sendqq.png" width="25" height="25">
              招标代理
            </div>
            <div style="cursor: pointer;font-weight: bold;text-decoration:underline;  font-size: 15px; color: #FFFFFF; text-align: left; margin-top: 5px;" @click="openQQ('2')">
              <img src="~@/assets/sendqq.png" width="25" height="25">
              投标企业1群
            </div>
            <div style="cursor: pointer;font-weight: bold;text-decoration:underline;  font-size: 15px; color: #FFFFFF; text-align: left; margin-top: 5px;" @click="openQQ('3')">
              <img src="~@/assets/sendqq.png" width="25" height="25">
              投标企业2群
            </div>
            <div style="cursor: pointer;font-weight: bold;text-decoration:underline;  font-size: 15px; color: #FFFFFF; text-align: left; margin-top: 5px;" @click="openQQ('4')">
              <img src="~@/assets/sendqq.png" width="25" height="25">
              投标企业3群
            </div>
          </div>
          <h3 style="cursor: pointer" @mouseenter="serviceMouseenter"  ></h3>
        </div>

        <div class="hotline">
          <div class="hotlineTextDiv" :class="{active: mouseOn}">
            <div style="font-weight: bold; font-size: 15px; color: #FFFFFF; text-align: center; margin-top: 5px;">0591-87585006</div>
            <div style="font-size: 14px; color: #FFFFFF">周一至周五<br/>09:00 - 17:30</div>
          </div>
          <h3 style="cursor: pointer" @mouseenter="hotlineMouseenter" @mouseleave="hotlineMouseleave"></h3>
        </div>

<!--        <div class="signature" >
          <a style="cursor: pointer" href="/signatureCard.html" target="_blank"></a>
        </div>-->
        <div class="operamanual"  @click="openOpera()" >
          <a style="cursor: pointer" href="javascript:;" ></a>
        </div>
        <img src="~@/assets/floatRight.png" @click="toggleSidebarCe" style="width:29px;position: absolute;top:247px;right:20px;">
      </div>
      <div v-show="isSidebarCeOpen" @click="toggleSidebarCe()" style="width: 30px; height: 60px; background: #1890FF; border-radius: 30px 0 0px 30px;">
        <img src="~@/assets/leftArrow.png"  style="width:28px;position: relative;top:16px;right:-9px;">
      </div>
    </div>
    <template v-if="layoutMode === 'sidemenu'">
      <a-drawer
        v-if="device === 'mobile'"
        :wrapClassName="'drawer-sider ' + navTheme"
        placement="left"
        @close="() => this.collapsed = false"
        :closable="false"
        :visible="collapsed"
        width="200px"
      >
        <side-menu
          mode="inline"
          v-if="device === 'mobile'"
          :menus="menus"
          @menuSelect="menuSelect"
          :theme="navTheme"
          :collapsed="false"
          :collapsible="true"></side-menu>
      </a-drawer>

      <side-menu
        v-show="device === 'desktop'"
        mode="inline"
        :menus="menus"
        @menuSelect="myMenuSelect"
        :theme="navTheme"
        :collapsed="collapsed"
        :collapsible="true"></side-menu>
    </template>
    <!-- 下次优化这些代码 -->
    <template v-else>
      <a-drawer
        v-if="device === 'mobile'"
        :wrapClassName="'drawer-sider ' + navTheme"
        placement="left"
        @close="() => this.collapsed = false"
        :closable="false"
        :visible="collapsed"
        width="200px"
      >
        <side-menu
          mode="inline"
          :menus="menus"
          @menuSelect="menuSelect"
          :theme="navTheme"
          :collapsed="false"
          :collapsible="true"></side-menu>
      </a-drawer>
    </template>

    <a-layout
      :class="[layoutMode, `content-width-${contentWidth}`]"
      :style="{ paddingLeft: fixSiderbar && isDesktop() ? `${sidebarOpened ? 200 : 80}px` : '0'}">
      <!-- layout header -->
      <global-header
        :mode="layoutMode"
        :menus="menus"
        :theme="navTheme"
        :collapsed="collapsed"
        :device="device"
        @toggle="toggle"
      />
      <!-- layout content -->
      <a-layout-content :style="{ height: '100%', paddingTop: fixedHeader ? '59px' : '0', }">
        <slot></slot>
      </a-layout-content>

      <!-- layout footer -->
      <a-layout-footer style="padding: 0px">
        <global-footer/>
      </a-layout-footer>
    </a-layout>

    <!-- update-start---- author:os_chengtgen -- date:20190830 --  for:issues/463 -编译主题颜色已生效，但还一直转圈，显示主题 正在编译 ---- -->
    <!--<setting-drawer></setting-drawer>-->
    <!-- update-end---- author:os_chengtgen -- date:20190830 --  for:issues/463 -编译主题颜色已生效，但还一直转圈，显示主题 正在编译 ---- -->
  </a-layout>
</template>

<script>
  import SideMenu from '@/components/menu/SideMenu'
  import GlobalHeader from '@/components/page/GlobalHeader'
  import GlobalFooter from '@/components/page/GlobalFooter'
  // update-start---- author:os_chengtgen -- date:20190830 --  for:issues/463 -编译主题颜色已生效，但还一直转圈，显示主题 正在编译 ------
  // import SettingDrawer from '@/components/setting/SettingDrawer'
  // 注释这个因为在个人设置模块已经加载了SettingDrawer页面
  // update-end ---- author:os_chengtgen -- date:20190830 --  for:issues/463 -编译主题颜色已生效，但还一直转圈，显示主题 正在编译 ------

  import { triggerWindowResizeEvent } from '@/utils/util'
  import { mapState, mapActions } from 'vuex'
  import { mixin, mixinDevice } from '@/utils/mixin.js'

  export default {
    name: 'GlobalLayout',
    components: {
      SideMenu,
      GlobalHeader,
      GlobalFooter,
      // update-start---- author:os_chengtgen -- date:20190830 --  for:issues/463 -编译主题颜色已生效，但还一直转圈，显示主题 正在编译 ------
      // // SettingDrawer
      // 注释这个因为在个人设置模块已经加载了SettingDrawer页面
      // update-end ---- author:os_chengtgen -- date:20190830 --  for:issues/463 -编译主题颜色已生效，但还一直转圈，显示主题 正在编译 ------

    },
    mixins: [mixin, mixinDevice],
    data() {
      return {
        collapsed: false,
        activeMenu:{},
        menus: [],
        isSidebarCeOpen:false,
        mouseOn: false,
        serviceMouseOn:false,
        signOn: false,
        roleCode:""
      }
    },
    computed: {
      ...mapState({
        // 主路由
        mainRouters: state => state.permission.addRouters,
        // 后台菜单
        permissionMenuList: state => state.user.permissionList
      })
    },
    watch: {
      sidebarOpened(val) {
        this.collapsed = !val
      }
    },
    created() {
      //--update-begin----author:scott---date:20190320------for:根据后台菜单配置，判断是否路由菜单字段，动态选择是否生成路由（为了支持参数URL菜单）------
      //this.menus = this.mainRouters.find((item) => item.path === '/').children;
      this.menus = this.permissionMenuList
      console.log(this.menus)
      let userInfo = this.$store.getters.userInfo;
      this.roleCode = userInfo.roleCode;
      // 根据后台配置菜单，重新排序加载路由信息
      //console.log('----加载菜单逻辑----')
      //console.log(this.mainRouters)
      //console.log(this.permissionMenuList)
      //console.log('----navTheme------'+this.navTheme)
      //--update-end----author:scott---date:20190320------for:根据后台菜单配置，判断是否路由菜单字段，动态选择是否生成路由（为了支持参数URL菜单）------
    },
    methods: {
      ...mapActions(['setSidebar']),
      toggle() {
        this.collapsed = !this.collapsed
        this.setSidebar(!this.collapsed)
        triggerWindowResizeEvent()
      },
      menuSelect() {
        if (!this.isDesktop()) {
          this.collapsed = false
        }
      },
      //update-begin-author:taoyan date:20190430 for:动态路由title显示配置的菜单title而不是其对应路由的title
      myMenuSelect(value){
        //此处触发动态路由被点击事件
        this.findMenuBykey(this.menus,value.key)
        this.$emit("dynamicRouterShow",value.key,this.activeMenu.meta.title)
        // update-begin-author:sunjianlei date:20191223 for: 修复刷新后菜单Tab名字显示异常
        let storeKey = 'route:title:' + this.activeMenu.path
        this.$ls.set(storeKey, this.activeMenu.meta.title)
        // update-end-author:sunjianlei date:20191223 for: 修复刷新后菜单Tab名字显示异常
      },
      findMenuBykey(menus,key){
        for(let i of menus){
          if(i.path==key){
            this.activeMenu = {...i}
          }else if(i.children && i.children.length>0){
            this.findMenuBykey(i.children,key)
          }
        }
      },
      toggleSidebarCe()
      {
        this.isSidebarCeOpen = !this.isSidebarCeOpen;
      },
      hotlineMouseenter() {
        this.mouseOn = true;
        this.serviceMouseOn = false;
      },
      hotlineMouseleave() {
        this.mouseOn = false;
      },
      serviceMouseenter() {
        this.serviceMouseOn = true;
      },
      serviceMouseleave() {
        this.serviceMouseOn = false;
      },
      openQQ(type)
      {
        let url=""
        if(type==="1")
        {
          window.open("http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=PpaUaolU_RCVZQOgmR8_Ogv6TRWtF-V7&authKey=kEL0%2B1rbAucqoPOKKJWmBbG9sk9p4RU%2BXPaUF3nFYedgee2fM2wsU26YsLw42QLQ&noverify=0&group_code=105393327")
        }else if(type==="2")
        {
          window.open("http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=u7elDLas21Qzd-Ff2j11zs3NVia6EQDQ&authKey=4nA6fhJxial6RGX%2F85%2B46EYrs%2B95SFIMhc1%2FTC3ixK2UY%2F0om539y%2B%2FLp3JA49FR&noverify=0&group_code=540062653")
        }
        else if(type==="3")
        {
          window.open("http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=xuk1dsmeXLJfkShiCTXSYnmW7z8ElJN9&authKey=PS09yk6UEJfkfdVb3YuI0FB3788qpYfbDprYTs6dserRDp1njYDC6SbBroVnc4%2Bb&noverify=0&group_code=632853381")
        }
        else if(type==="4")
        {
          window.open("http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=_Yjr94CXmMGlUk49AhHypnwA-11fNrbX&authKey=gxEmtp%2FNaV33upJDb3sSI5ynK1coA9vgZM21Kdl0tKXvSkh4w5hWCXnaFgoEXS6A&noverify=0&group_code=580013049")
        }
      },
      openOpera()
      {
        window.open("https://fzztb.fzsggzyjyfwzx.cn/portal/news?classifyCode=A01A01A01")
      }
    }
  }

</script>

<style lang="less">
  body {
    // 打开滚动条固定显示
    overflow-y: scroll;

    &.colorWeak {
      filter: invert(80%);
    }
  }

  .layout {
    min-height: 100vh !important;
    overflow-x: hidden;

    &.mobile {

      .ant-layout-content {

        .content {
          margin: 24px 0 0;
        }
      }

      /**
       * ant-table-wrapper
       * 覆盖的表格手机模式样式，如果想修改在手机上表格最低宽度，可以在这里改动
       */
      .ant-table-wrapper {
        .ant-table-content {
          overflow-y: auto;
        }
        .ant-table-body {
          min-width: 800px;
        }
      }
      .sidemenu {
        .ant-header-fixedHeader {

          &.ant-header-side-opened, &.ant-header-side-closed {
            width: 100%
          }
        }
      }

      .topmenu {
        /* 必须为 topmenu  才能启用流式布局 */
        &.content-width-Fluid {
          .header-index-wide {
            margin-left: 0;
          }
        }
      }
      .header, .top-nav-header-index {
        .user-wrapper .action {
          padding: 0 12px;
        }
      }
    }

    &.ant-layout-has-sider {
      flex-direction: row;
    }

    .trigger {
      font-size: 22px;
      line-height: 42px;
      padding: 0 18px;
      cursor: pointer;
      transition: color 300ms, background 300ms;

      &:hover {
        background: rgba(255, 255, 255, 0.3);
      }
    }

    .topmenu {
      .ant-header-fixedHeader {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 9;
        width: 100%;
        transition: width .2s;

        &.ant-header-side-opened {
          width: 100%;
        }

        &.ant-header-side-closed {
          width: 100%;
        }
      }
      /* 必须为 topmenu  才能启用流式布局 */
      &.content-width-Fluid {
        .header-index-wide {
          max-width: unset;
          margin-left: 24px;
        }

        .page-header-index-wide {
          max-width: unset;
        }
      }

    }

    .sidemenu {
      .ant-header-fixedHeader {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 9;
        width: 100%;
        transition: width .2s;

        &.ant-header-side-opened {
          width: calc(100% - 200px)
        }

        &.ant-header-side-closed {
          width: calc(100% - 80px)
        }
      }
    }

    .header {
      height: 64px;
      padding: 0 12px 0 0;
      background: #fff;
      box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
      position: relative;
    }

    .header, .top-nav-header-index {

      .user-wrapper {
        float: right;
        height: 100%;

        .action {
          cursor: pointer;
          padding: 0 14px;
          display: inline-block;
          transition: all .3s;

          height: 70%;
          line-height: 46px;

          &.action-full {
            height: 100%;
          }

          &:hover {
            background: rgba(255, 255, 255, 0.3);
          }

          .avatar {
            margin: 20px 10px 20px 0;
            color: #1890ff;
            background: hsla(0, 0%, 100%, .85);
            vertical-align: middle;
          }

          .icon {
            font-size: 16px;
            padding: 4px;
          }

          .anticon {
            color: inherit;
          }
        }
      }

      &.dark {
        .user-wrapper {

          .action {
            color: black;

            &:hover {
              background: rgba(0, 0, 0, 0.05);
            }

            .anticon {
              color: inherit;
            }
          }
        }
      }
    }

    &.mobile {
      .top-nav-header-index {

        .header-index-wide {

          .header-index-left {

            .trigger {
              color: rgba(255, 255, 255, 0.85);
              padding: 0 12px;
            }

            .logo.top-nav-header {
              text-align: center;
              width: 56px;
              line-height: 58px;
            }
          }
        }

        .user-wrapper .action .avatar {
          margin: 20px 0;
        }

        &.light {

          .header-index-wide {

            .header-index-left {
              .trigger {
                color: rgba(0, 0, 0, 0.65);
              }
            }
          }
          //
        }
      }
    }

    &.tablet {
      // overflow: hidden; text-overflow:ellipsis; white-space: nowrap;
      .top-nav-header-index {

        .header-index-wide {

          .header-index-left {
            .logo > a {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }

    }

    .top-nav-header-index {
      box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
      position: relative;
      transition: background .3s, width .2s;

      .header-index-wide {
        width: 100%;
        margin: auto;
        padding: 0 20px 0 0;
        display: flex;
        height: 59px;

        .ant-menu.ant-menu-horizontal {
          border: none;
          height: 64px;
          line-height: 64px;
        }

        .header-index-left {
          flex: 1 1;
          display: flex;

          .logo.top-nav-header {
            width: 165px;
            height: 64px;
            position: relative;
            line-height: 64px;
            transition: all .3s;
            overflow: hidden;

            img {
              display: inline-block;
              vertical-align: middle;
              height: 32px;
            }

            h1 {
              color: #fff;
              display: inline-block;
              vertical-align: top;
              font-size: 16px;
              margin: 0 0 0 12px;
              font-weight: 400;
            }
          }
        }

        .header-index-right {
          float: right;
          height: 59px;
          overflow: hidden;
          .action:hover {
            background-color: rgba(0, 0, 0, 0.05);
          }
        }
      }

      &.light {
        background-color: #fff;

        .header-index-wide {
          .header-index-left {
            .logo {
              h1 {
                color: #002140;
              }
            }
          }
        }
      }

      &.dark {

        .user-wrapper {

          .action {
            color: white;

            &:hover {
              background: rgba(255, 255, 255, 0.3);
            }
          }
        }
        .header-index-wide .header-index-left .trigger:hover {
          background: rgba(255, 255, 255, 0.3);
        }
      }

    }

    // 内容区
    .layout-content {
      margin: 24px 24px 0px;
      height: 64px;
      padding: 0 12px 0 0;
    }

  }

  .topmenu {
    .page-header-index-wide {
      margin: 0 auto;
      width: 100%;
    }
   /deep/ .ant-menu-dark{
     background-color: rgb(48, 65, 86);
     /deep/ .ant-menu-submenu:hover{
       background-color: #263445;
     }
     /deep/ .ant-menu-item:hover{
       background-color: #263445;
     }
   }
    /deep/ .ant-menu.ant-menu-dark .ant-menu-item-selected{
      background-color: #263445;
    }
    /deep/ .ant-menu.ant-menu-dark .ant-menu-item-selected i{
      color: rgb(24, 144, 255);
    }
    /deep/ .ant-menu.ant-menu-dark .ant-menu-item-selected span{
      color: rgb(24, 144, 255);
    }
    /deep/ .ant-menu-dark .ant-menu-submenu-active{
      color: #FFFFFF !important;
    }
  }
   .dark.header-index-right{
    background-color: rgb(48, 65, 86) !important;
  }
   .layout .top-nav-header-index.dark .user-wrapper .action:hover{
    background-color: #263445 !important;
  }
  .layout .top-nav-header-index .dark .user-wrapper .action i{
    color: #FFFFFF !important;
  }
  .layout .top-nav-header-index .user-wrapper .action .anticon{
    color: inherit !important;
  }
  .dark.ant-dropdown-menu{
    background-color: #999999;
  }
  // drawer-sider 自定义
  .ant-drawer.drawer-sider {
    .sider {
      box-shadow: none;
    }

    &.dark {
      .ant-drawer-content {
        background-color: rgb(0, 21, 41);
      }
    }
    &.light {
      box-shadow: none;
      .ant-drawer-content {
        background-color: #fff;
      }
    }

    .ant-drawer-body {
      padding: 0
    }
  }

  // 菜单样式
  .sider {
    box-shadow: 2px 116px 6px 0 rgba(0, 21, 41, .35);
    position: relative;
    z-index: 10;

    &.ant-fixed-sidemenu {
      position: fixed;
      height: 100%;
    }

    .logo {
      height: 64px;
      position: relative;
      line-height: 64px;
      padding-left: 24px;
      -webkit-transition: all .3s;
      transition: all .3s;
      background: #002140;
      overflow: hidden;

      img, h1 {
        display: inline-block;
        vertical-align: middle;
      }

      img {
        height: 32px;
      }

      h1 {
        color: #fff;
        font-size: 18px;
        margin: 0 0 0 8px;
        font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
        font-weight: 600;
      }
    }

    &.light {
      background-color: #fff;
      box-shadow: 2px 116px 8px 0 rgba(29, 35, 41, 0.05);

      .logo {
        background: #fff;
        box-shadow: 1px 1px 0 0 #e8e8e8;

        h1 {
          color: unset;
        }
      }

      .ant-menu-light {
        border-right-color: transparent;
      }
    }

  }

  // 外置的样式控制
  .user-dropdown-menu-wrapper.ant-dropdown-menu {
    padding: 4px 0;

    .ant-dropdown-menu-item {
      width: 160px;
    }

    .ant-dropdown-menu-item > .anticon:first-child,
    .ant-dropdown-menu-item > a > .anticon:first-child,
    .ant-dropdown-menu-submenu-title > .anticon:first-child
    .ant-dropdown-menu-submenu-title > a > .anticon:first-child {
      min-width: 12px;
      margin-right: 8px;
    }

  }

  // 数据列表 样式
  .table-alert {
    margin-bottom: 16px;
  }

  .table-page-search-wrapper {

    .ant-form-inline {

      .ant-form-item {
        display: flex;
        margin-bottom: 24px;
        margin-right: 0;

        .ant-form-item-control-wrapper {
          flex: 1 1;
          display: inline-block;
          vertical-align: middle;
        }

        > .ant-form-item-label {
          line-height: 32px;
          padding-right: 8px;
          width: auto;
        }
        .ant-form-item-control {
          height: 32px;
          line-height: 32px;
        }
      }
    }

    .table-page-search-submitButtons {
      display: block;
      margin-bottom: 24px;
      white-space: nowrap;
    }

  }

  .content {

    .table-operator {
      margin-bottom: 18px;

      button {
        margin-right: 8px;
      }
    }
  }
 .ant-menu-dark .ant-menu-vertical.ant-menu-sub li:hover{
    background-color: #001528;
  }
   .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected{
     background-color: #001528 !important;
  }
  .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected span{
    color: rgb(24, 144, 255);
  }
   .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected i{
    color: rgb(24, 144, 255);
  }
  .ant-menu-dark .ant-menu-sub{
    background: #1f2d3d !important;
   .ant-menu-submenu-open,.ant-menu-submenu-active{
      color: #FFFFFF !important;
    }
  }
  .floatBtn{
    position: fixed;
    right: 0;
    top: 47%;
    transform: translateY(-50%);
    padding: 10px
  }
  .service {
    width: 76px;
    position: absolute;
    right: 0px;
    top: 0px;
    margin-top: -70px;
    z-index: 99;
    transition: all 0.3s ease 0s;
  }

  .serviceTextDiv {
    width: 140px;
    top: 0px;
    height: 140px;
    right: 80px;
    position: absolute;
    background: #2189e5;
    border-radius: 5px 5px 5px 5px;
    text-align: center;
    visibility: hidden;
  }

  .serviceTextDiv.active {
    visibility: visible;
  }

  .service h3 {
    width: 74px;
    height: 74px;
    margin: 0;
    float: right;
    background: url("~@/assets/portal/在线客服.png") no-repeat center;
    color: #fff;
    font-size: 14px;
    text-align: center;
    border-radius: 8px 0 0 8px;
  }

  .hotline {
    position: absolute;
    right: 0px;
    top: 80px;
    margin-top: -70px;
    z-index: 99;
    transition: all 0.3s ease 0s;
  }

  .hotlineTextDiv {
    width: 156px;
    top: 0px;
    height: 74px;
    right: 80px;
    position: absolute;
    background: #2189e5;
    border-radius: 5px 5px 5px 5px;
    text-align: center;
    visibility: hidden;
  }

  .hotlineTextDiv.active {
    visibility: visible;
  }

  .hotline h3 {
    width: 74px;
    height: 74px;
    margin: 0;
    float: right;
    background: url("~@/assets/portal/咨询热线.png") no-repeat center;
    color: #fff;
    font-size: 14px;
    text-align: center;
    border-radius: 8px 0 0 8px;
  }
  .signature{
    position: absolute;
    right: 0px;
    top: 170px;
    margin-top: -80px;
    z-index: 99;
    transition: all 0.3s ease 0s;
  }

  .signature a {
    width: 74px;
    height: 74px;
    margin: 0;
    padding-top: 45px;
    float: right;
    background: url("~@/assets/portal/new统一.png") no-repeat center;
    background-size: cover;
    color: #fff;
    font-size: 14px;
    text-align: center;
    border-radius: 8px 0 0 8px;
  }

  .operamanual{
    position: absolute;
    right: 0px;
    top: 170px;
    margin-top: -80px;
    z-index: 99;
    transition: all 0.3s ease 0s;
  }
  .operamanual a {
    width: 74px;
    height: 74px;
    margin: 0;
    padding-top: 45px;
    float: right;
    background: url("~@/assets/opearmanual.png") no-repeat center;
    background-size: cover;
    color: #fff;
    font-size: 14px;
    text-align: center;
    border-radius: 8px 0 0 8px;
  }
  .arrow {
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-bottom: 40px solid red;
  }
</style>
